import React, { useState } from 'react';

import Alert from 'CommonComponents/Alert';

export default function IntegrationsSetupListItem(props) {
    const [request, setRequest] = useState(false);

    const checkConnection = () => {
        if (props.provider.integration) {
            setRequest(true);

            const url = props.checkConnectivityUrl.replace('INTEGRATION_ID', props.provider.integration.id);
            axios
                .post(url)
                .then((res) => {
                    alert($t('Connection successful'));
                })
                .catch((e) => {
                    alert(e.response.data.error);
                })
                .finally(() => {
                    setRequest(false);
                });
        }
    };

    return (
        <div className="table__card">
            <div className="tw-flex tw-items-center tw-mr-2">
                <div style={{ maxWidth: '75px', maxHeight: '75px' }}>
                    <img alt={props.provider.name} src={props.provider.logo} />
                </div>
                <div>
                    {props.provider.name}{' '}
                    {!!props.provider.integration && (
                        <span className="tw-bg-green-100 tw-text-green-800 tw-text-xs tw-font-medium tw-me-2 tw-px-2.5 tw-py-0.5 tw-rounded">
                            {$t('Configured')}
                        </span>
                    )}
                </div>
            </div>
            <div className="tw-flex tw-items-center tw-justify-between mt-3">
                {!!props.provider.integration && (
                    <button className="button primary" onClick={props.displaySetupInfo}>
                        <i className="fa fa-exclamation-triangle mr-1" aria-hidden="true"></i> {$t('Set up')}
                    </button>
                )}
                {props.provider.can_be_configured && (
                    <button className="button primary" onClick={props.configureProvider}>
                        {$t('Configure')}
                    </button>
                )}
                {!props.provider.can_be_configured && (
                    <Alert className="tw-my-2" type="warning">
                        {$t('Only one integration per category can be configured.')}
                    </Alert>
                )}
            </div>
            {!!props.provider.integration && (
                <div className="tw-flex tw-items-center tw-justify-between mt-3">
                    <button className="button primary" onClick={checkConnection} disabled={request}>
                        {!!request && <i className="fa fa-spinner fa-spin " aria-hidden="true"></i>}
                        {$t('Check Connectivity')}
                    </button>
                    {!!props.provider.reconnect_url && (
                        <button
                            className="button primary"
                            onClick={() => {
                                window.location.href = props.provider.reconnect_url;
                            }}
                        >
                            {$t('Reconnect')}
                        </button>
                    )}
                </div>
            )}
        </div>
    );
}
